import { render, staticRenderFns } from "./RatingStatisticsPage.vue?vue&type=template&id=4b2eef7d&scoped=true&lang=pug"
import script from "./RatingStatisticsPage.vue?vue&type=script&lang=ts"
export * from "./RatingStatisticsPage.vue?vue&type=script&lang=ts"
import style0 from "./RatingStatisticsPage.vue?vue&type=style&index=0&id=4b2eef7d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.42_css-loader@6.11.0_webpack@5.109.2_postcss@8_1f9207239c89e69c02e913826d327f44/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2eef7d",
  null
  
)

export default component.exports